import { motion } from 'framer-motion';
import { socialIcons, socialButtons } from '../data/linktree2-links';

// ═══════════════════════════════════════════════════════════════════
// Los links se configuran en: src/data/linktree2-links.ts
// Los logos de redes van en: public/social_logos2/
// ═══════════════════════════════════════════════════════════════════

export function LinkTree2() {
  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4  relative overflow-hidden"
      style={{
        backgroundImage: 'url(/fondos/LIEC_FONDO_TREE.jpeg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Overlay oscuro para mejorar legibilidad */}
      <div className="absolute inset-0" />
      
      <div className="relative z-10 w-full max-w-md px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8 mt-2"
        >
          {/* Logo con badge de Mérida */}
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
            className="mb-8 flex justify-center"
          >
            <div className="relative">
              <img 
                src="/liec-logo.png" 
                alt="Logo" 
                className="w-32 h-32 object-contain rounded-full "
              />
              {/* Imagen Mérida en esquina inferior derecha */}
              <img 
                src="/merida.svg" 
                alt="Mérida" 
                className="absolute -bottom-8 -right-8 w-30 h-auto "
              />
            </div>
          </motion.div>

          {/* Nombre de la empresa */}
          <motion.h1
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="text-white font-bold text-3xl mb-2"
          >
            LIEC S.A. DE C.V.
          </motion.h1>

          {/* Tagline */}
          <motion.h4
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="text-white text-lg mb-8"
          >
            Expertos en Control de Calidad de Materiales en México
          </motion.h4>
        </motion.div>

        {/* Iconos de redes sociales */}
        <div className="flex justify-center gap-3 mb-8">
          {socialIcons.map((link, index) => (
            <motion.div
              key={link.name}
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.5 + index * 0.1 }}
              className="w-10 h-10"
            >
              <img 
                src={link.logo} 
                alt={link.name} 
                className="w-full h-full object-contain"
              />
            </motion.div>
          ))}
        </div>

        {/* Botones de enlaces */}
        <div className="space-y-4">
          {socialButtons.map((link, index) => (
            <motion.a
              key={link.name}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 + index * 0.1 }}
              className="block w-full"
            >
              <div className="bg-transparent border-2 border-white p-1 m-5 shadow-lg">
                <span className="text-xl font-medium text-white text-center block">{link.name}</span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </div>
  );
}
